import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Globe, ArrowRight, Volume2 } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './LanguageModal.module.css';

const LanguageModal = () => {
  const { isModalOpen, selectLanguage } = useLanguage();

  const languages = [
    { code: 'en', name: 'English', native: 'English' },
    { code: 'hi', name: 'Hindi', native: 'हिंदी' },
    { code: 'mr', name: 'Marathi', native: 'मराठी' },
    { code: 'kn', name: 'Kannada', native: 'ಕನ್ನಡ' },
    { code: 'bn', name: 'Bangla', native: 'বাংলা' },
    { code: 'te', name: 'Telugu', native: 'తెలుగు' },
    { code: 'ta', name: 'Tamil', native: 'தமிழ்' },
    { code: 'gu', name: 'Gujarati', native: 'ગુજરાતી' },
  ];

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modalCard}
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 150 }}
          >
            {/* Header branding */}
            <div className={styles.header}>
              <div className={styles.iconCircle}>
                <Globe className={styles.globeIcon} size={28} />
              </div>
              <h2 className={styles.title}>ANANTA AI ANCHORS</h2>
              <p className={styles.subtitle}>
                Choose your news channel language
              </p>
              <p className={styles.hindiSubtitle}>
                अपने समाचार चैनल की भाषा चुनें
              </p>
            </div>

            {/* Language Grid */}
            <div className={styles.grid}>
              {languages.map((lang, idx) => (
                <motion.button
                  key={lang.code}
                  className={styles.langBtn}
                  onClick={() => selectLanguage(lang.code)}
                  whileHover={{ scale: 1.03, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.05 }}
                >
                  <span className={styles.nativeName}>{lang.native}</span>
                  <span className={styles.englishName}>{lang.name}</span>
                  <ArrowRight className={styles.arrow} size={14} />
                </motion.button>
              ))}
            </div>

            {/* Audio Tip */}
            <div className={styles.audioTip}>
              <Volume2 size={16} className={styles.audioIcon} />
              <span>Selecting a language will automatically play AI anchor voice demo</span>
            </div>
            <div className={styles.audioTipHindi}>
              <span>भाषा चुनते ही AI एंकर की आवाज़ का डेमो शुरू हो जाएगा</span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LanguageModal;
